module.exports = __webpack_public_path__ + "img/avatar.14cf1734.jpg";